import { Typography } from "@mui/material";
import _ from "lodash";
import React, { useMemo } from "react";
import {
  CellProps,
  ColumnDefinition,
  TableDefinition,
  TileTable,
} from "../../../../common/components/TileTable";
import { useDataMapCollectedPICGroups } from "../../../../common/service/resources/data-map/dataMapTransformers";
import { CollectionGroupDetailsDto } from "../../../../common/service/server/dto/CollectionGroupDto";
import {
  DataMapDto,
  PICGroupWithCategories,
} from "../../../../common/service/server/dto/datamap/DataMapDto";
import { EmptyInfo } from "../../../components/Empty";
import { GroupIcon } from "../../get-compliant/data-map/GroupIcon";

const NameCell: React.FC<CellProps<PICGroupWithCategories>> = ({ data }) => (
  <span className="d-flex flex-row">
    <GroupIcon groupName={data.name} color="primary" />

    <div>
      <Typography>{data.name}</Typography>
      <Typography className="color-neutral-600" variant="caption">
        {data.categories.map((g) => g.name).join(", ")}
      </Typography>
    </div>
  </span>
);

export const COLLECTION_GROUP_COLUMNS: ColumnDefinition<PICGroupWithCategories>[] = [
  {
    heading: null,
    component: NameCell,
  },
];

export const CollectionGroupCollectedPicTable: React.FC<{
  collectionGroup: CollectionGroupDetailsDto;
  dataMap: DataMapDto;
}> = ({ collectionGroup, dataMap }) => {
  const collectedPicGroups = useDataMapCollectedPICGroups(dataMap, {
    collectionGroupId: collectionGroup.id,
  });
  const sortedPicGroups = useMemo(
    () => _.sortBy(collectedPicGroups, ["order", "name"]),
    [collectedPicGroups],
  );

  if (!sortedPicGroups || sortedPicGroups.length < 1) {
    return <EmptyInfo>No data collected</EmptyInfo>;
  }

  const table: TableDefinition<PICGroupWithCategories> = {
    data: sortedPicGroups,
    columns: COLLECTION_GROUP_COLUMNS,
  };

  return <TileTable variant="filled" table={table} />;
};
